"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../namespaces");
exports.JsonLdHelper = {
    validKeys(instance, nonHydra = false) {
        return Object.keys(instance).filter(_ => _.length > 0 && _.charAt(0) !== "@" && (!nonHydra || Object.keys(namespaces_1.hydra).indexOf(_) === -1));
    }
};
//# sourceMappingURL=JsonLdHelper.js.map